/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	InternshipDTO,
	InternshipDTOFromJSON,
	InternshipDTOFromJSONTyped,
	InternshipDTOToJSON,
} from "./InternshipDTO";

/**
 *
 * @export
 * @interface InternshipDTOPagedResponse
 */
export interface InternshipDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof InternshipDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof InternshipDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof InternshipDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<InternshipDTO>}
	 * @memberof InternshipDTOPagedResponse
	 */
	data?: Array<InternshipDTO> | null;
}

export function InternshipDTOPagedResponseFromJSON(
	json: any
): InternshipDTOPagedResponse {
	return InternshipDTOPagedResponseFromJSONTyped(json, false);
}

export function InternshipDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): InternshipDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(InternshipDTOFromJSON),
	};
}

export function InternshipDTOPagedResponseToJSON(
	value?: InternshipDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(InternshipDTOToJSON),
	};
}
